var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { FileUploadService } from "~/services/file-service/file-upload.service";
var LawsuitFollowRegister = /** @class */ (function (_super) {
    __extends(LawsuitFollowRegister, _super);
    function LawsuitFollowRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.initModel = {
            lawsuit: '',
            judge: '',
            createCaseTime: '',
            lawerCaseNumber: '',
            lawsuitRecord: '',
            isNotice: 'NO',
            noticeTime: '',
            isLawerProtect: 'NO',
            protectDetail: '',
            updateRealName: '',
            operatorRealName: '',
            recordRemark: '',
        };
        _this.model = __assign({}, _this.initModel);
        _this.rules = {
            lawsuit: [{ required: true, message: "请输入法院", trigger: "blur" }],
            createCaseTime: [{ required: true, message: "请输入立案时间", trigger: "blur" }],
            lawerCaseNumber: [{ required: true, message: "请输入诉讼案件号", trigger: "blur" }],
            lawsuitRecord: [{ required: true, message: "请输入诉讼立案标的", trigger: "blur" }],
            isNotice: [{ required: true, message: "请选择是否办理公告", trigger: "blur" }],
            isLawerProtect: [{ required: true, message: "请选择是否诉讼保全", trigger: "blur" }],
            recordRemark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        };
        return _this;
    }
    LawsuitFollowRegister.prototype.revertData = function (data) {
        this.model.lawsuit = data.lawsuit;
        this.model.judge = data.judge;
        this.model.createCaseTime = data.createCaseTime;
        this.model.lawerCaseNumber = data.lawerCaseNumber;
        this.model.lawsuitRecord = data.lawsuitRecord;
        this.model.isNotice = data.isNotice;
        this.model.noticeTime = data.noticeTime;
        this.model.isLawerProtect = data.isLawerProtect;
        this.model.protectDetail = data.protectDetail;
        this.model.updateRealName = this.userData.realName;
        this.model.recordRemark = data.recordRemark;
        this.model.operatorRealName = this.follower;
        this.callbackFileList(data.recordFileIds);
    };
    LawsuitFollowRegister.prototype.reset = function () {
        var form = this.$refs['form'];
        form.resetFields();
        this.fileList = [];
        this.model.operatorRealName = this.follower;
        this.model.updateRealName = this.userData.realName;
    };
    LawsuitFollowRegister.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var form, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = this.$refs['form'];
                        return [4 /*yield*/, form.validate().then(function (resolve) {
                                var tepmFileIds = _this.fileList.length === 0 ? "" : _this.fileList.map(function (v) { return v.response.id; }).join(",");
                                return __assign(__assign({}, _this.model), { recordFileIds: tepmFileIds });
                            }).catch(function (rejected) {
                                return false;
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    LawsuitFollowRegister.prototype.callbackFileList = function (fileIds) {
        var _this = this;
        if (!fileIds)
            return;
        this.fileUploadService.getAllUploadFileByIds(fileIds).subscribe(function (data) {
            if (!data || data.length === 0)
                return;
            _this.fileList = data.map(function (v) {
                return { name: v.originalName, response: { id: v.id } };
            });
        });
    };
    __decorate([
        Dependencies(FileUploadService)
    ], LawsuitFollowRegister.prototype, "fileUploadService", void 0);
    __decorate([
        Prop({ default: false })
    ], LawsuitFollowRegister.prototype, "isView", void 0);
    __decorate([
        Prop()
    ], LawsuitFollowRegister.prototype, "follower", void 0);
    __decorate([
        State
    ], LawsuitFollowRegister.prototype, "userData", void 0);
    LawsuitFollowRegister = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], LawsuitFollowRegister);
    return LawsuitFollowRegister;
}(Vue));
export default LawsuitFollowRegister;
